import { type FC } from "react";
import { Alert, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ContactImportTotals } from "../model/importChunks";

interface ImportResultAlertProps {
  totals: ContactImportTotals;
}

/** Итог импорта: сумма по всем прошедшим пачкам. */
export const ImportResultAlert: FC<ImportResultAlertProps> = ({ totals }) => {
  const { t } = useTranslation();
  const lines = [
    t("marketingContacts.import.result.added", { count: totals.added }),
    t("marketingContacts.import.result.updated", { count: totals.updated }),
    t("marketingContacts.import.result.invalid", { count: totals.invalid }),
    t("marketingContacts.import.result.duplicates", {
      count: totals.duplicates,
    }),
    t("marketingContacts.import.result.matchedViewers", {
      count: totals.matchedViewers,
    }),
  ];
  return (
    <Alert severity="success">
      {lines.map((line) => (
        <Typography key={line} variant="body2">
          {line}
        </Typography>
      ))}
    </Alert>
  );
};
